<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/warn_index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>任务面板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 预警任务面板 -->
    <!-- <h2 class="el_h2">预警任务面板</h2>
    <el-table
    :data="listData"
    highlight-current-row
    border
    >
      <el-table-column align="center" label="id" type="index"></el-table-column>
      <el-table-column align="center" sortable prop="warnDesc" label="预警模块名称"></el-table-column>
      <el-table-column align="center" sortable prop="warnCount" label="预警数量">
        <template slot-scope="scope">
          <el-link style="color: skyblue;" @click="to_warnlist(scope.row)">{{scope.row.warnCount}}</el-link>
        </template>
      </el-table-column>
    </el-table> -->
    <!-- 工单任务面板 -->
    <h2 class="el_h2">工单任务面板:(近一个月内)</h2>
    <el-table
    :data="work_data"
    highlight-current-row
    @cell-click="check_work_order"
    border
    >
      <el-table-column
      align="center"
      prop="acceptUserName"
      label="授理人"></el-table-column>
      <el-table-column
      align="center"
      sortable
      prop="unClosedCount"
      class-name="work_column"
      label="处理中">
        <template slot-scope="scope">
          <span>{{scope.row.unClosedCount==null?0:scope.row.unClosedCount}}</span>
        </template>
      </el-table-column>
      <el-table-column
      align="center"
      sortable
      prop="closedCount"
      class-name="work_column"
      label="已关单">
        <template slot-scope="scope">
          <span>{{scope.row.closedCount==null?0:scope.row.closedCount}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;">
      <el-button>待处理数量:{{work_total_num.unHandleNum==null?0:work_total_num.unHandleNum}}</el-button>
      <el-button>处理中数量:{{work_total_num.handleNum==null?0:work_total_num.handleNum}}</el-button>
      <el-button>待确认数量:{{work_total_num.waitConfirm==null?0:work_total_num.waitConfirm}}</el-button>
      <el-button>已关单数量:{{work_total_num.closeHandle==null?0:work_total_num.closeHandle}}</el-button>
      <el-button>工单总数:{{work_total_num.totalNum==null?0:work_total_num.totalNum}}</el-button>
    </div>
    <!-- 定时器日志弹框 -->
    <el-dialog
    title="预警列表"
    :append-to-body='true'
    customClass="customWidth"
    :visible.sync="dialogTableVisible">
      <!-- 预警任务详情 -->
      <el-dialog
      title="详情"
      :visible.sync="innerVisible"
      :append-to-body='true'
      >
        <el-form
        ref="detail_form"
        :model="detail_form"
        label-width="100px"
        >
          <div v-show="type=='Timer'">
            <el-form-item label="定时任务ID">
              <el-input v-model="detail_form.timerId" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="运行时间">
              <el-input v-model="detail_form.runTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="日志">
              <el-input style="height: 50px;" type="textarea" v-model="detail_form.text" :readonly="true"></el-input>
            </el-form-item>
          </div>
          <div v-show="type=='Error'">
            <el-form-item label="错误ID">
              <el-input v-model="detail_form.errorId" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="操作时间">
              <el-input v-model="detail_form.errorAddTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="操作人">
              <el-input v-model="detail_form.errorAddWho" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="修改时间">
              <el-input v-model="detail_form.errorEditTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="修改人">
              <el-input v-model="detail_form.errorEditWho" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="错误日志">
              <el-input style="height: 50px;" type="textarea" v-model="detail_form.errorMessage" :readonly="true"></el-input>
            </el-form-item>
          </div>
          <div v-show="type=='Delete'">
            <el-form-item label="表名">
              <el-input v-model="detail_form.tableName" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="操作时间">
              <el-input v-model="detail_form.addTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="操作人">
              <el-input v-model="detail_form.addWho" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="修改时间">
              <el-input v-model="detail_form.editTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="修改人">
              <el-input v-model="detail_form.editWho" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="关键字1">
              <el-input style="height: 50px;" type="textarea" v-model="detail_form.keyWord1" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="关键字2">
              <el-input style="height: 50px;" type="textarea" v-model="detail_form.keyWord2" :readonly="true"></el-input>
            </el-form-item>
          </div>
          <div v-show="type=='Dock'">
            <el-form-item label="ID">
              <el-input v-model="detail_form.mainId" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="新增时间">
              <el-input v-model="detail_form.dockAddTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="更新时间">
              <el-input v-model="detail_form.dockUpdateTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="接口名称">
              <el-input v-model="detail_form.interFaceName" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="客户ID">
              <el-input v-model="detail_form.customerId" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model="detail_form.customerName" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="日志类型">
              <el-input v-model="detail_form.logType" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="接口ID">
              <el-input v-model="detail_form.interfaceId" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="日志">
              <el-input style="height: 100px;" type="textarea" v-model="detail_form.msg" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="发送数据">
              <el-input style="height: 200px;" type="textarea" v-model="detail_form.sendData" :readonly="true"></el-input>
            </el-form-item>
          </div>
          <div v-show="type=='scLog'">
            <el-form-item label="ID">
              <el-input v-model="detail_form.scMainId" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="错误类型">
              <el-input v-model="detail_form.scLogType" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <el-input v-model="detail_form.scAddTime" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="模块名称">
              <el-input v-model="detail_form.moduleName" :readonly="true"></el-input>
            </el-form-item>
            <el-form-item label="日志">
              <el-input style="height: 50px;" type="textarea" v-model="detail_form.scText" :readonly="true"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </el-dialog>
      <el-table
      :data="dialog_list"
      max-height="300"
      v-show="type=='Timer'"
      @row-dblclick='timer_dblclick($event)'
      >
        <el-table-column align="center" type="index" sortable label="id"></el-table-column>
        <el-table-column align="center" prop="timerId" label="定时任务ID"></el-table-column>
        <el-table-column align="center" prop="runTime" sortable label="运行时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="text" label="日志"></el-table-column>
      </el-table>
      <el-table
      :data="dialog_list"
      max-height="300"
      v-show="type=='Delete'"
      @row-dblclick='timer_dblclick($event)'
      >
        <el-table-column align="center" type="index" sortable label="id"></el-table-column>
        <el-table-column align="center" prop="tableName" sortable label="表名"></el-table-column>
        <el-table-column align="center" prop="addTime" label="操作时间"></el-table-column>
        <el-table-column align="center" prop="keyWord1" label="关键字1"></el-table-column>
        <el-table-column align="center" prop="keyWord2" label="关键字2"></el-table-column>
      </el-table>
      <el-table
      :data="dialog_list"
      max-height="300"
      v-show="type=='Error'"
      @row-dblclick='timer_dblclick($event)'
      >
        <el-table-column align="center" type="index" sortable label="id"></el-table-column>
        <el-table-column align="center" prop="errorId" sortable label="错误ID"></el-table-column>
        <el-table-column align="center" prop="addTime" label="操作时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="errorMessage" label="错误日志"></el-table-column>
      </el-table>
      <el-table
      :data="dialog_list"
      max-height="300"
      v-show="type=='Dock'"
      @row-dblclick='timer_dblclick($event)'
      >
        <el-table-column align="center" type="index" sortable label="id"></el-table-column>
        <el-table-column align="center" prop="mainId" sortable label="ID"></el-table-column>
        <el-table-column align="center" prop="addTime" label="发生时间"></el-table-column>
        <el-table-column align="center" prop="updateTime" label="再次发生时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="msg" label="日志"></el-table-column>
      </el-table>
      <el-table
      :data="dialog_list"
      max-height="300"
      v-show="type=='scLog'"
      @row-dblclick='timer_dblclick($event)'
      >
        <el-table-column align="center" type="index" label="id"></el-table-column>
        <el-table-column align="center" prop="moduleName" label="模块名称"></el-table-column>
        <el-table-column align="center" prop="logType" label="错误类型"></el-table-column>
        <el-table-column align="center" prop="addTime" label="时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="text" label="日志"></el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from './Pagination'
  export default {
    data(){
      return{
        listData:[],//预警任务
        work_data:[],//工单任务
        work_total_num:{},
        dialog_list:[],
        dialogTableVisible:false,
        innerVisible:false,
        warning_url:'',
        type:null,
        //分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        //详情
        detail_form:{
          timerId:'',
          runTime:'',
          text:'',
          errorId:'',
          errorAddTime:'',
          errorAddWho:'',
          errorEditTime:'',
          errorEditWho:'',
          errorMessage:'',
          tableName:'',
          addTime:'',
          addWho:'',
          editTime:'',
          editWho:'',
          keyWord1:'',
          keyWord2:'',
          mainId:'',
          dockAddTime:'',
          dockUpdateTime:'',
          interFaceName:'',
          customerId:'',
          customerName:'',
          logType:'',
          interfaceId:'',
          msg:'',
          sendData:'',
          scMainId:'',
          scLogType:'',
          scAddTime:'',
          moduleName:'',
          scText:''
        },
        //权限数组
        btn_permission:null
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //预警任务
      // that.$axios({
      //   method:'get',
      //   url:that.publicAjax.env+'/waringManage/sysWaring/warn/list'
      // }).then(data=>{
      //   that.listData=data.data.queryResult.listData
      // })
      //工单任务
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/sccOwn/orderWork/getDemandTask',
      }).then(data=>{
        that.work_data=data.data.data.handleVos
        that.work_total_num=data.data.data
      })
    },
    mounted() {

    },
    methods:{
      //工单任务列表单元格单击事件
      check_work_order(row, column, cell, event){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/user/permission',
          headers:{
            "scctoken": localStorage.getItem(localStorage.getItem('userName')+'token'),
            "content-type":"application/x-www-form-urlencoded"
          }
        }).then(data=>{
          if(data.data.success==true){
            that.btn_permission=data.data.data
            if(that.btn_permission.includes('scc:demandMange:handle')==false&&that.btn_permission.includes('superAdmin')==false){
              that.$message.warning('该用户暂无权限！')
              return false
            }
            if(column.label!='授理人'){
              that.$router.push({
                name:'manage_list',
                params:{
                  handleUserId:row.acceptUserId,
                  work_status:column.label=='处理中'?'101':'111'
                }
              })
            }
          }else{

          }
        })
      },
      //分页组件事件
      callFather(params){
        this.pageparm.currentPage=params.currentPage
        this.pageparm.pageSize=params.pageSize
        //获取预警列表
        this.warning_list()
      },
      //预警列表前置
      to_warnlist(row,id){
        let that=this
        let warnName=row.warnName
        let warnCount=row.warnCount
        that.publicAjax.axios_set()
        if(warnName=='SYS_Timer_Log'){
          that.type='Timer'
        }else if(warnName=='SYS_Delete_Log'){
          that.type='Delete'
        }else if(warnName=='SYS_ERROR_LOG'){
          that.type='Error'
        }else if(warnName=='DOCK_ERROR'){
          that.type='Dock'
        }else if(warnName=='SC_Log'){
          that.type='scLog'
        }
        if(warnCount==0){
          that.$message.error({
            showClose:true,
            message:'预警数量为0！'
          })
        }else{
          this.pageparm.currentPage=1
          this.pageparm.pageSize=10
          //获取预警列表
          that.warning_list()
        }
      },
      //获取预警列表
      warning_list(){
        let that=this
        that.dialogTableVisible=true
        if(that.type=='Timer'){
          that.warning_url='/waringManage/sysWaring/warn/todayList/Timer'
        }else if(that.type=='Error'){
          that.warning_url='/waringManage/sysWaring/warn/todayList/Error'
        }else if(that.type=='Delete'){
          that.warning_url='/waringManage/sysWaring/warn/todayList/Delete'
        }else if(that.type=='Dock'){
          that.warning_url='/waringManage/sysWaring/warn/todayList/Dock'
        }else if(that.type=='scLog'){
          that.warning_url='/waringManage/sysWaring/warn/todayList/scLog'
        }
        //获取日志列表
        that.$axios({
          method:'get',
          url:that.publicAjax.env+that.warning_url+'?page='+that.pageparm.currentPage+'&limit='+that.pageparm.pageSize
        }).then(data=>{
          if(data.data.success==false){
            that.$message.error(data.data.message)
          }else{
            that.dialog_list=data.data.queryResult.listData
            that.pageparm.total=data.data.queryResult.total
          }
        })
      },
      //任务面板详情
      timer_dblclick(event){
        let that=this
        that.innerVisible=true
        if(that.type=='Timer'){
          //定时器日志详情
          that.$axios({
            method:'get',
            url:that.publicAjax.env+'/waringManage/sysWaring/timer/'+event.runTime
          }).then(data=>{
            that.detail_form.timerId=data.data.queryResult.timerId
            that.detail_form.runTime=data.data.queryResult.runTime
            that.detail_form.text=data.data.queryResult.text
          })
        }else if(that.type=='Delete'){
          //删除日志详情
          that.$axios({
            method:'get',
            url:that.publicAjax.env+'/waringManage/sysWaring/delete/'+event.runTime
          }).then(data=>{
            that.detail_form.tableName=data.data.queryResult.tableName
            that.detail_form.keyWord1=data.data.queryResult.keyWord1
            that.detail_form.keyWord2=data.data.queryResult.keyWord2
            that.detail_form.addTime=data.data.queryResult.addTime
            that.detail_form.addWho=data.data.queryResult.addWho
            that.detail_form.editTime=data.data.queryResult.editTime
            that.detail_form.editWho=data.data.queryResult.editWho
          })
        }else if(that.type=='Error'){
          //错误日志详情
          that.$axios({
            method:'get',
            url:that.publicAjax.env+'/waringManage/sysWaring/error/'+event.runTime
          }).then(data=>{
            that.detail_form.errorId=data.data.queryResult.errorId
            that.detail_form.errorAddTime=data.data.queryResult.addTime
            that.detail_form.errorAddWho=data.data.queryResult.addWho
            that.detail_form.errorEditTime=data.data.queryResult.editTime
            that.detail_form.errorEditWho=data.data.queryResult.editWho
            that.detail_form.errorMessage=data.data.queryResult.errorMessage
          })
        }else if(that.type=='Dock'){
          //对接系统错误日志详情
          that.$axios({
            method:'get',
            url:that.publicAjax.env+'/waringManage/sysWaring/dock/'+event.runTime
          }).then(data=>{
            that.detail_form.mainId=data.data.queryResult.mainId
            that.detail_form.dockAddTime=data.data.queryResult.addTime
            that.detail_form.dockUpdateTime=data.data.queryResult.updateTime
            that.detail_form.interFaceName=data.data.queryResult.interFaceName
            that.detail_form.customerId=data.data.queryResult.customerId
            that.detail_form.customerName=data.data.queryResult.customerName
            that.detail_form.logType=data.data.queryResult.logType
            that.detail_form.interfaceId=data.data.queryResult.interfaceId
            that.detail_form.msg=data.data.queryResult.msg
            that.detail_form.sendData=data.data.queryResult.sendData
          })
        }else if(that.type=='scLog'){
          //SC系统错误日志详情
          that.$axios({
            method:'get',
            url:that.publicAjax.env+'/waringManage/sysWaring/scLog/'+event.runTime
          }).then(data=>{
            that.detail_form.scMainId=data.data.queryResult.mainId
            that.detail_form.scAddTime=data.data.queryResult.addTime
            that.detail_form.moduleName=data.data.queryResult.moduleName
            that.detail_form.scLogType=data.data.queryResult.logType
            that.detail_form.scText=data.data.queryResult.text
          })
        }
      }
    }
  }
</script>

<style scoped="scoped">
  .el-breadcrumb{
    font-size: 16px;
  }
  .el_h2{
    border-left: 4px solid #409EFF;
    padding: 10px;
    margin: 20px 0;
    font-size: 16px;
    background: #F5F7FA;
  }
  .el-table{
    border-bottom: 1px solid #EBEEF5;
  }
  /deep/ .work_column{
    cursor: pointer;
    color: #409EFF;
  }
</style>
<style>
  .customWidth{
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/components/warn_index.vue